import React from 'react'
import ReelVideo from '@components/common/ReelVideo/ReelVideo'
import { IImageGalleryRef } from './ProductImageGallery'

const NeedMomizedProductVideo = ({
  src,
  title,
  galleryRef,
}: {
  src: string
  title: string
  galleryRef: React.RefObject<IImageGalleryRef>
}) => (
  <div className="flex items-center justify-center bg-black rounded-xl md:rounded-3xl video-wrapper">
    <ReelVideo
      src={src}
      title={title}
      onPlay={() => {
        galleryRef?.current?.pause()
      }}
      onPause={() => {
        const currentIndex = galleryRef?.current?.getCurrentIndex()
        const nextIndex = currentIndex + 1

        setTimeout(() => {
          galleryRef?.current?.slideToIndex(nextIndex)
          galleryRef?.current?.play()
        }, 1000)
      }}
    />
  </div>
)

export const ProductVideo = React.memo(
  NeedMomizedProductVideo,
  (prevProps, nextProps) => prevProps.src === nextProps.src
)
